<div *ngFor="let key of objectKeys; trackBy: trackByIndex">
  <div style="margin-bottom: 12px;">
    <label><strong>{{ key }}</strong></label>
    <ng-container [ngSwitch]="getType(data[key])">
      <!-- Primitive types -->
      <input *ngSwitchCase="'string'" nz-input [ngModel]="data[key]" (ngModelChange)="onChangeString($event,data,key)"/>
      <input *ngSwitchCase="'number'" nz-input type="number" [ngModel]="data[key]" #value (ngModelChange)="onChangeNumberValue($event,data,key)" />
      <label *ngSwitchCase="'boolean'" nz-checkbox [(ngModel)]="data[key]" class="checkbox-json-editor"  (ngModelChange)="onChangeString($event,data,key)"> {{ key }}</label>

      <!-- Nested object -->
      <div *ngSwitchCase="'object'" style="margin-left: 20px;">
        <!-- Add new key-value pair
        <div style="margin-top: 8px;">
            <input nz-input [(ngModel)]="newKey" placeholder="New key" style="width: 40%;" />
            <button nz-button nzType="default" (click)="addObjectKey()">Add</button>
        </div> -->
        <json-forms-node-new [data]="data[key]" [path]="path.concat([key])"></json-forms-node-new>
      </div>

      <!-- Array -->
      <div *ngSwitchCase="'array'" style="margin-left: 20px;">
        
          <div *ngFor="let item of data[key]; let i = index; trackBy: trackByIndex">
            <expanse-panel [title]="'row['+i+']'" startOpen="true">
              <ng-container [ngSwitch]="getType(item)">
                <input *ngSwitchCase="'string'" nz-input [(ngModel)]="data[key][i]"  (ngModelChange)="onChangeString($event,data,key)"/>
                <input *ngSwitchCase="'number'" nz-input type="number" [ngModel]="data[key][i]" (ngModelChange)="onChangeNumberValue($event,data,key)"/>
                <label *ngSwitchCase="'boolean'" nz-checkbox [(ngModel)]="data[key][i]" class="checkbox-json-editor"  (ngModelChange)="onChangeString($event,data,key)">Item {{ i }}</label>

                <!-- Array of objects -->
                <div *ngSwitchCase="'object'" style="margin-left: 20px;">
                  <json-forms-node-new [data]="item" [path]="path.concat([key, i.toString()])"></json-forms-node-new>
                </div>
              </ng-container>
            </expanse-panel>
          </div>
        
      </div>
    </ng-container>
  </div>
</div>